import { media } from '@helpers/media_templates';
import styled from 'styled-components';

export const OUTER_PADDING = {
  small: '0',
  medium: '20px',
  large: '40px',
};

export const INNER_PADDING = {
  small: '60px 20px',
  medium: '80px 40px',
  large: '80px 60px',
};

export const BodyWrapper = styled.div`
  display: grid;
  width: 100%;
  padding: 0 ${OUTER_PADDING.small};

  grid-template-columns: 1fr [body-start] minmax(auto, 1360px) [body-end] 1fr;
  grid-template-rows: ${props => props.rows};

  ${media.medium`
  padding: 0 ${OUTER_PADDING.medium};
  `}

  ${media.large`
    padding: 0 ${OUTER_PADDING.large};
  `}

  > * {
    grid-column: body;
  }
`;

export const Body = styled.div`
  background: ${props => props.theme.body};
  padding: ${INNER_PADDING.small};
  grid-area: body;

  ${media.medium`
    padding: ${INNER_PADDING.medium};
  `}

  ${media.large`
    padding: ${INNER_PADDING.large};
  `}
`;
